const API_BASE = 'https://forms.unitymakers.com.br/api';

const montarHeaders = (headersExtra) => {
  const token = localStorage.getItem('unity_token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...headersExtra,
  };
};

export const apiGet = (caminho) =>
  fetch(`${API_BASE}${caminho}`, { headers: montarHeaders() }).then((r) => r.json());

export const apiPost = (caminho, corpo) =>
  fetch(`${API_BASE}${caminho}`, {
    method: 'POST',
    headers: montarHeaders(),
    body: JSON.stringify(corpo),
  }).then((r) => r.json());
